<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-12 mb-2 mt-1">
        <div class="row breadcrumbs-top">
          <div class="col-12">
            <h5 class="content-header-title float-left pr-1 mb-0" v-if="proposal.property && proposal.property.address">{{ proposal.property.address.street }}, {{ countryName(proposal.country) }}</h5>
            <h5 class="content-header-title float-left pr-1 mb-0" v-else>-</h5>
            <div class="breadcrumb-wrapper col-12">
              <ol class="breadcrumb p-0 mb-0">
                <li class="breadcrumb-item">
                  <router-link :to="{name: 'DashboardPage' }">
                    <em class="bx bx-home-alt"></em>
                  </router-link>
                </li>
                <li class="breadcrumb-item">
                  <router-link :to="{name: 'ContractProposalSinglePage', params: {uid: $route.params.uuid} }">
                    <span v-if="proposal.property && proposal.property.address">{{ proposal.property.address.street }}, {{ countryName(proposal.country) }}</span>
                    <span v-else>-</span>
                  </router-link>
                </li>
                <li class="breadcrumb-item active">{{$t('Edit Proposal')}}</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-body">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-content" id="proposal-card-body">
              <div class="card-body">
                <Alert
                  v-if="error == 'fill-data'"
                  :text="$t('Validation for the required fields')"
                  type="danger"
                  dismissable="false"
                />
                <Alert
                  v-if="error == 'error-message'"
                  :text="errorText"
                  type="danger"
                  dismissable="false"
                />
                <Alert
                  v-if="error == 'change-status'"
                  :text="errorText"
                  type="danger"
                  dismissable="false"
                />
                <form class="form">
                  <div class="form-body">
                    <div class="row">
                      <div class="col-md-4 col-sm-12">
                        <div>
                          <label for>{{$t('House')}}</label>
                          <select
                            id="house-select"
                            class="form-control select2"
                            style="width: 100%;"
                            disabled
                          >
                            <option value="Choose Property..." selected disabled>{{$t('Choose Property...')}}</option>
                            <option
                              :value="property.uid"
                              v-for="(property, index) in properties"
                              :key="index"
                              :selected="property.uid == currentHouse"
                            >{{ property.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-12">
                        <div>
                          <label for>{{$t('Tenant')}}</label>
                          <select
                            id="tenant-select"
                            class="form-control select2"
                            :disabled="inviteTenant"
                            style="width: 100%;"
                          >
                            <option value="Choose Tenant..." selected disabled>{{$t('Choose Tenant...')}}</option>
                            <option
                              :value="JSON.stringify(tenant)"
                              v-for="(tenant, index) in tenants"
                              :key="index"
                              :selected="JSON.stringify(tenant) == JSON.stringify(currentTenant)"
                            >{{ (tenant.name) ? tenant.name : '-' }}</option>
                          </select>
                          <small v-if="!inviteTenant">
                            <a href="#" @click="toggleInviteTenant()" class="pl-0">{{$t('Invite tenant')}}</a>
                          </small>
                          <small v-else>
                            <a
                              href="#"
                              @click="toggleInviteTenant()"
                              class="pl-0"
                            >{{$t('Choose tenant from list')}}</a>
                          </small>
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-12">
                          <label for="">{{$t('Status')}}</label>
                          <select v-model="proposalStatus" class="form-control capitalize" :disabled="proposal.creationStatus != 'draft_by_admin' && proposal.creationStatus != 'needs_approval_by_admin'" v-if="proposal.creationStatus">
                              <option v-if="proposal.creationStatus != 'draft_by_admin' && proposal.creationStatus != 'needs_approval_by_admin'" :value="proposal.creationStatus" selected>{{ proposal.creationStatus.replaceAll("_", " ") }}</option>
                              <option v-if="proposal.creationStatus == 'draft_by_admin'" value="draft_by_admin" selected>{{$t('Draft by Admin')}}</option>
                              <option v-if="proposal.creationStatus == 'draft_by_admin'" value="needs_approval_by_landlord">{{$t('Needs Approval by Landlord')}}</option>
                              <option v-if="proposal.creationStatus == 'needs_approval_by_admin'" value="needs_approval_by_admin">{{$t('Needs Approval by Admin')}}</option>
                              <option v-if="proposal.creationStatus == 'needs_approval_by_admin'" value="needs_approval_by_landlord">{{$t('Needs Approval by Landlord')}}</option>
                              <option v-if="proposal.creationStatus == 'needs_approval_by_admin'" value="approved">{{$t('Approved')}}</option>
                          </select>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-md-6 col-sm-12">
                        <div>
                          <label for>{{$t('Contract Template')}}</label>
                          <select
                            id="template-select"
                            class="form-control select2"
                            style="width: 100%;"
                          >
                            <option value="Choose Template..." selected disabled>{{$t('Choose Template...')}}</option>
                            <option
                              :value="template.uid"
                              v-for="(template, index) in templates"
                              :key="index"
                              :selected="template.uid == currentTemplate"
                            >{{ template.docusignTemplate.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for>{{$t('Rent Start')}}</label>
                        <div class="form-group position-relative has-icon-left">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Select Date"
                            id="date-input-proposal"
                          />
                          <div class="form-control-position">
                            <em class="bx bx-calendar"></em>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 col-sm-12">
                        <div>
                          <label for>{{$t('Contract Duration (In months)')}}</label>
                          <input
                            type="number"
                            placeholder="12"
                            step="1"
                            min="0"
                            class="form-control"
                            v-model="contractDuration"
                          />
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for>{{$t('Payment Recurrence (In months)')}}</label>
                        <select class="form-control" v-model="paymentRecurrence">
                          <option value="1">{{$t('Each month')}}</option>
                          <option value="3">{{$t('Every three months')}}</option>
                          <option value="6">{{$t('Every six months')}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-md-6 col-sm-12">
                        <label for="">{{$t('Payment Method')}}</label>
                        <select class="select2 form-control" multiple="multiple" id="payment-method-select">
                            <option value="cash" :selected="paymentTypes.includes('cash')">{{$t('Cash')}}</option>
                            <option value="cheque" :selected="paymentTypes.includes('cheque')">{{$t('Cheque')}}</option>
                            <option value="wire_transfer" :selected="paymentTypes.includes('wire_transfer')">{{$t('Wire Transfer')}}</option>
                            <option value="mobile_transfer" :selected="paymentTypes.includes('mobile_transfer')">{{$t('Mobile Transfer')}}</option>
                            <option value="in_kind" :selected="paymentTypes.includes('in_kind')">{{$t('In Kind')}}</option>
                        </select>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label>{{$t('Creation status description')}}</label>
                        <input type="text" class="form-control" v-model="creationStatusDescription" :disabled="proposal.creationStatus !== 'needs_approval_by_admin'">
                      </div>
                    </div>
                  </div>

                  <div v-if="inviteTenant">
                    <br />
                    <div class="text-left my-2">
                      <h4 class="text-bold-600">{{$t('Invite Tenant')}}</h4>
                      <hr />
                    </div>

                    <div class="form-group row">
                      <div class="col-md-6 col-sm-12">
                        <label for>{{$t('Name')}}</label>
                        <input type="text" class="form-control" v-model="tenantName" />
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for>{{$t('Language')}}</label>
                        <select class="form-control" v-model="tenantLanguage">
                          <option value="en">{{$t('English')}}</option>
                          <option value="ar">{{$t('Arabic')}}</option>
                        </select>
                      </div>
                    </div>

                    <div class="form-group row">
                      <div class="col-md-6 col-sm-12">
                        <label for>{{$t('Phone Number')}}</label>
                        <input
                          type="tel"
                          id="phoneNumber"
                          class="form-control"
                          v-model="invitePhoneNumber"
                        />
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for>{{$t('Email Address')}}</label>
                        <input type="text" class="form-control" v-model="tenantEmail" />
                      </div>
                    </div>
                  </div>

                  <div v-if="showTemplateInformations">
                    <br />
                    <div class="text-left my-2">
                      <h4 class="text-bold-600">{{$t('Template Informations')}}</h4>
                      <hr />
                    </div>

                    <div class="row">
                      <div class="col-md-6 col-sm-12">
                        <label>{{$t('Title (EN)')}}:</label>
                        <div class="form-group">
                          <input
                            type="text"
                            :placeholder="$t('Contract Title')"
                            class="form-control"
                            :value="singleTemplate.details.en.name"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label>{{$t('Title (AR)')}}:</label>
                        <div class="form-group">
                          <input
                            type="text"
                            :placeholder="$t('Contract Title')"
                            class="form-control text-right"
                            :value="singleTemplate.details.ar.name"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 col-sm-12">
                        <label>{{$t('Country')}}:</label>
                        <div class="form-group">
                          <select class="form-control" disabled>
                            <option selected>{{ countryName(singleTemplate.country) }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label>{{$t('Type')}}:</label>
                        <div class="form-group">
                          <select id class="form-control" disabled :value="singleTemplate.type">
                            <option
                              value="Occupancy Free of Charge Lease"
                            >{{$t('Occupancy Free of Charge Lease')}}</option>
                            <option value="Standard Residential Lease">{{$t('Standard Residential Lease')}}</option>
                            <option value="Rent Reduction Lease">{{$t('Rent Reduction Lease')}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for>{{$t('Description (EN)')}}</label>
                        <textarea
                          cols="30"
                          rows="7"
                          class="form-control"
                          disabled
                          :value="singleTemplate.details.en.description"
                        ></textarea>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for>{{$t('Description (AR)')}}</label>
                        <textarea
                          cols="30"
                          rows="7"
                          class="form-control text-right"
                          disabled
                          :value="singleTemplate.details.ar.description"
                        ></textarea>
                      </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                      <div class="col-md-6 col-sm-12">
                        <label>Status:</label>
                        <div class="form-group">
                          <select class="form-control" disabled :value="singleTemplate.status">
                            <option value="draft">{{$t('Draft')}}</option>
                            <option value="published">{{$t('Published')}}</option>
                            <option value="archived">{{$t('Archived')}}</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="text-left my-2">
                      <h6 class="text-bold-600">{{$t('Terms and Conditions')}}</h6>
                    </div>
                    <div>
                      <div data-repeater-item v-for="(term, index) in terms" :key="index">
                        <div class="row">
                          <div class="col-6">
                            <div class="row justify-content-between">
                              <div class="col-md-8 col-sm-8 form-group">
                                <label for>{{$t('Term Title (EN)')}}</label>
                                <input
                                  type="text"
                                  class="form-control term-title-edit"
                                  :placeholder="$t('Enter term title')"
                                  :value="term.title"
                                  disabled
                                />
                              </div>
                              <div class="col-md-12 col-sm-12 form-group">
                                <label for="password">{{$t('Term Description (EN)')}}</label>
                                <textarea
                                  cols="30"
                                  rows="5"
                                  class="form-control term-description-edit"
                                  :placeholder="$t('Enter term description...')"
                                  :value="term.description"
                                  disabled
                                ></textarea>
                              </div>
                            </div>
                          </div>

                          <div class="col-6">
                            <div class="row justify-content-between">
                              <div class="col-md-8 col-sm-8 form-group">
                                <label for>{{$t('Term Title (AR)')}}</label>
                                <input
                                  type="text"
                                  class="form-control term-title-edit-ar text-right"
                                  :placeholder="$t('Enter term title')"
                                  :value="termsAr[index].title"
                                  disabled
                                />
                              </div>
                              <div class="col-md-2 col-sm-2"></div>
                              <div class="col-md-12 col-sm-12 form-group">
                                <label for="password">{{$t('Term Description (AR)')}}</label>
                                <textarea
                                  cols="30"
                                  rows="5"
                                  class="form-control term-description-edit-ar text-right"
                                  :placeholder="$t('Enter term description...')"
                                  :value="termsAr[index].description"
                                  disabled
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr />
                      </div>
                    </div>
                  </div>

                  <div class="text-right mt-2">
                    <button
                      class="btn btn-primary"
                      type="button"
                      style="margin-top: 0px !important;"
                      @click="editProposal()"
                    >{{$t('Save Changes')}}</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCountryName } from "@/app-assets/js/get-countries.js";
import "@/app-assets/js/scripts/extensions/ext-component-block-ui.js";
import Alert from "@/components/Alerts";
import CreateHouse from "@/components/Houses/CreateHouse";
export default {
  data() {
    return {
      proposal: {},
      proposalUUID: this.$route.params.uuid,

      proposalStatus: "",

      error: "",
      errorText: "",

      templates: [],
      showTemplateInformations: false,
      singleTemplate: {},
      terms: [],
      termsAr: [],

      properties: [],

      tenants: [],
      inviteTenant: false,

      propertyUUID: "",
      templateUUID: "",
      contractDuration: "",
      paymentRecurrence: "1",

      phoneNumberObj: null,
      invitePhoneNumber: "",
      tenantName: "",
      tenantEmail: "",
      tenantLanguage: "en",

      currentHouse: '',
      currentTemplate: '',
      currentTenant: '',

      creationStatusDescription: '',
      paymentTypes: []
    };
  },

  computed: {
    isSuperadmin() {
      return this.$store.state.currentUser.user.type === "superadmin";
    },
  },

  components: {
    Alert,
    CreateHouse,
  },

  methods: {

    editProposal() {
      this.error = "";
      this.errorText = ""
      let canEdit = true;
      let rentStart = null;
      let owner = null;
      let data = null;

      if (this.inviteTenant) {
        owner = {
          name: this.tenantName,
          language: this.tenantLanguage,
          email: this.tenantEmail,
          phoneNumber: this.invitePhoneNumber,
        };
      } else {
        let v = JSON.parse($("#tenant-select").val());

        if (v && (this.currentTenant.uid != v.uid)) {
          owner = {
            name: v.name,
            language: v.language,
            email: v.email ? v.email : null,
            phoneNumber: v.phoneNumber ? v.phoneNumber : null,
          };
        }
      }

      let body = {
        propertyId: $("#house-select").val(),
        creationStatus:this.proposalStatus
      };


      if ($("#date-input-proposal").val().trim() != "") {
        rentStart = $("#date-input-proposal").val().split("/");
        rentStart = `${rentStart[2]}-${rentStart[0]}-${rentStart[1]}T00:00Z`;

        body.data = {
          rentStart: rentStart,
          contractDuration: Number(this.contractDuration),
          paymentRecurrence: Number(this.paymentRecurrence),
          paymentTypes: $("#payment-method-select").val()
        };
      }

      if ($("#template-select").val()) {
        body.templateId = $("#template-select").val();
      }

      // if (owner) {
      //   body.tenant = owner;
      // }

      if(!$("#house-select").val()){
        this.error = "error-message";
        this.errorText = `$t('property validation')`;
        return;
      }

      // Check status change
      if(this.proposalStatus == 'needs_approval_by_landlord' || this.proposalStatus == 'approved'){
        if(
          body.propertyId &&
          body.templateId &&
          // body.tenant &&
          body.data && 
          body.data.contractDuration != 0 && 
          body.data.paymentRecurrence != 0
        ){
          canEdit = true;
        } else{
          canEdit = false;
          this.error = 'change-status';
          this.errorText = `$t('status change validation') <strong>${this.proposalStatus.replaceAll('_', ' ')}</strong>!`
        }
      }

      if(canEdit){

        var block_ele = $("#proposal-card-body");
        $(block_ele).block({
          message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
          overlayCSS: {
            backgroundColor: "#fff",
            opacity: 0.8,
            cursor: "wait",
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: "transparent",
          },
        });

        this.$apiCall.patch(`/v1/contracts/proposals/${this.proposalUUID}`, body)
        .then(response => {
          if(this.proposalStatus == 'needs_approval_by_landlord'){
            this.$apiCall.patch(`/v1/contracts/proposals/${this.proposalUUID}/status`, {
              creationStatus: 'needs_approval_by_landlord',
              creationStatusDescription: this.creationStatusDescription
            })
            .then(response => {
              $(block_ele).unblock();
              location.reload();
            })
            .catch(error => {
              $(block_ele).unblock();
              this.error = "error-message";
              this.errorText = `$t('Ops') ${error.response.data.message}`;
              $("html, body").animate(
                {
                  scrollTop: $("body").offset().top,
                },
                500
              );
            })
          } else if(this.proposalStatus === 'needs_approval_by_admin'){
            this.$apiCall.patch(`/v1/contracts/proposals/${this.proposalUUID}/status`, {
              creationStatusDescription: this.creationStatusDescription
            })
            .then(response => {
              $(block_ele).unblock();
              location.reload();
            })
            .catch(error => {
              $(block_ele).unblock();
              this.error = "error-message";
              this.errorText = `$t('Ops') ${error.response.data.message}`;
              $("html, body").animate(
                {
                  scrollTop: $("body").offset().top,
                },
                500
              );
            })
          } else if(this.proposalStatus == 'approved'){
            this.$apiCall.patch(`/v1/contracts/proposals/${this.proposalUUID}/status`, {
              creationStatus: 'approved',
              creationStatusDescription: this.creationStatusDescription
            })
            .then(response => {
              $(block_ele).unblock();
              location.reload();
            })
            .catch(error => {
              $(block_ele).unblock();
              this.error = "error-message";
              this.errorText = `$t('Ops') ${error.response.data.message}`;
              $("html, body").animate(
                {
                  scrollTop: $("body").offset().top,
                },
                500
              ); 
            })
          } else{
            $(block_ele).unblock();
            location.reload();
          }
        })
        .catch(error => {
          $(block_ele).unblock();
          this.error = "error-message";
          this.errorText = `$t('Ops') ${error.response.data.message}`;
          $("html, body").animate(
            {
              scrollTop: $("body").offset().top,
            },
            500
          );
        })
      }

    },

    getProposal() {
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });

      this.$apiCall
        .get(`/v1/contracts/proposals/${this.proposalUUID}`)
        .then((response) => {
          this.proposal = response.data;

          this.currentHouse = response.data.property.uid;
          this.currentTemplate = response.data.templateId;
          if(response.data.tenants){
            if(response.data.tenants[0].user){
              this.currentTenant = response.data.tenants[0].user;
            } else if(response.data.tenants[0].invite){
              const t = response.data.tenants[0].invite;
              this.inviteTenant = true;
              this.tenantName = t.name;
              this.tenantEmail = t.email;
              this.invitePhoneNumber = t.phoneNumber;
              this.tenantLanguage = t.language;
              this.currentTenant = response.data.tenants[0].invite;
              setTimeout(() => {
                this.initTelInput();
              }, 500)
            }
          }

          this.paymentTypes = (this.proposal.data && this.proposal.data.paymentTypes) ? this.proposal.data.paymentTypes : [];
          
          setTimeout(() => {
            $("#payment-method-select").select2({
              placeholder: "Choose payment methods..."
            });
          }, 500)

          this.creationStatusDescription = (response.data.creationStatusDescription) ? response.data.creationStatusDescription : "";

          this.contractDuration = response.data.data ? response.data.data.contractDuration : "";
          this.paymentRecurrence = response.data.data ? response.data.data.paymentRecurrence : "1";

          this.proposalStatus = response.data.creationStatus;

          if(response.data.data){
              let date = response.data.data.rentStart.split('T')[0].split('-');
              $("#date-input-proposal").val(`${date[1]}/${date[2]}/${date[0]}`);
          }

          this.initPage();
        })
        .catch((err) => {
          console.log(err);
          $.unblockUI();
        });
    },

    initPage() {
      if (!this.tenants.length && !this.properties.length) {
        let uri = [
          this.$apiCall.get("/v1/properties"),
          this.$apiCall.get("/v1/users?type=tenant"),
          this.$apiCall.get("/v1/contracts/templates?status=published"),
        ];

        Promise.all(uri)
          .then((response) => {
            $.unblockUI();
            this.properties = response[0].data.data;
            this.tenants = response[1].data.data;
            this.templates = response[2].data.data;
            $("#house-select").select2();
            $("#tenant-select").select2();
            $("#template-select").select2();
            $("#create-proposal-modal").modal();
          })
          .catch((error) => {
            $.unblockUI();
            console.log(error);
          });
      } else {
        $("#create-proposal-modal").modal();
      }
    },

    getTemplateInformations(uuid) {
      var block_ele = $("#proposal-card-body");
      $(block_ele).block({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });
      this.$apiCall
        .get(`/v1/contracts/templates/${uuid}`)
        .then((response) => {
          $(block_ele).unblock();
          this.showTemplateInformations = true;
          this.singleTemplate = response.data;
          this.terms = this.singleTemplate.terms.en;
          this.termsAr = this.singleTemplate.terms.ar;
        })
        .catch((error) => {
          $(block_ele).unblock();
          console.log(error);
        });
    },

    initTelInput() {
      let input = document.querySelector("#phoneNumber");
      this.phoneNumberObj = intlTelInput(input);
    },

    toggleInviteTenant() {
      this.inviteTenant = !this.inviteTenant;
      if (this.inviteTenant) {
        setTimeout(() => {
          this.initTelInput();
        }, 100);
      }
    },

    handleNewHouseCreation() {
      var block_ele = $("#proposal-card-body");
      $(block_ele).block({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });

      this.properties = [];

      this.$apiCall
        .get("/v1/properties")
        .then((response) => {
          this.properties = response.data.data;
          $("#house-select").html("");
          $("#house-select").select2();
          $(block_ele).unblock();
        })
        .catch((error) => {
          $(block_ele).unblock();
          this.error = "error-message";
          this.errorText = `$t('Ops') ${error.response.data.message}`;
          $("html, body").animate(
            {
              scrollTop: $("body").offset().top,
            },
            500
          );
        });
    },

    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },
  },

  mounted() {
    let self = this;

    this.getProposal();

    $("#template-select").on("change", function () {
      let val = $(this).val();
      self.getTemplateInformations(val);
    });

    setTimeout(() => {
      const pD = $("#date-input-proposal").pickadate(
        {
          format: "mm/dd/yyyy",
        },
        200
      );
    });
  },

  watch: {
    invitePhoneNumber: function (value) {
      this.invitePhoneNumber = value.replace(/[^\d|\-+]/g, "");
    },
  },
};
</script>